// Theme colours
export const TEXT_COLOR = "#495057";
export const TEXT_COLOR_SECONDARY = "#6c757d";
export const SURFACE_BORDER = "#dee2e6";
export const PRIMARY_COLOR = "#3b82f6";
export const PRIMARY_LIGHT_COLOR = "#a0d2fa";
export const INDIGO_COLOR = "#3f51b5";
export const INDIGO_LIGHT_COLOR = "#6372c3";
export const PURPLE_COLOR = "#9c27b0";
export const PURPLE_LIGHT_COLOR = "#af50bf";
export const TEAL_COLOR = "#009688";
export const TEAL_LIGHT_COLOR = "#30aa9f";
export const ORANGE_COLOR = "#f57c00";

export const COCHARGE_DARK_GREEN = "#225349";
export const COCHRAGE_DARK_GREEN_RGBA = (alpha) => `rgba(34, 83, 73, ${alpha})`;
export const LIGHT_GREEN = "#45ca47";
export const COCHARGE_LIGHT_LIME = "#c3e76b";       // brand lime (accent/hover)
export const COCHARGE_LIGHT_LIME_TINT = "#eef7d6";  // ~20% lime, row stripe (readable text)

// BOF-76 charging station dashboard — chart series colours. Validated with the dataviz palette checks
// against the white chart surface (lightness band, chroma floor, CVD and normal-vision separation,
// contrast), all pairs, not eyeballed. The PRIMARY_COLOR / COCHARGE_DARK_GREEN pair used for AC/DC on
// Operations Review fails those checks (the dark green reads as gray), so it is not reused here.
// Colour follows the entity across every panel: AC is always blue, DC always orange.
export const CHART_AC = "#2a78d6";
export const CHART_DC = "#eb6834";
// Below 3:1 on white, so every use carries a visible value beside it (tile, legend, tooltip).
export const CHART_ONLINE = "#1baf7a";
// Deliberately neutral: remainders (unclassified sessions, charge points not online, the total line).
export const CHART_NEUTRAL = "#8a8f98";
export const CHART_GRID = "#eef0f2";
// KPI score trend: three lines that cross, so validated all-pairs and kept apart from the AC / DC /
// online identities above. Magenta and yellow are below 3:1 on white, so the trend ships with a table
// of the same scores beside it.
export const CHART_SCORE_OVERALL = "#4a3aa7";
export const CHART_SCORE_OPERATIONAL = "#e87ba4";
export const CHART_SCORE_MONETIZATION = "#eda100";
